export function isEnabledQueryFlag(params: URLSearchParams, name: string): boolean {
  return params.get(name) === '1';
}
